import React, { useMemo, useState } from 'react';
import { Icon, IconsEnum } from 'components/Icons';

import classNames from 'classnames';
import styles from './ScommesseTableShowMore.module.scss';
import { selectIsVisualizzazioneEstesa } from 'features/settings/selectors';
import { useTypedSelector } from 'lib/centralStore';

export type ScommesseTableShowMoreProps = {
  className?: string;
  results?: number;
};

export const ScommesseTableShowMore = ({ className, results }: ScommesseTableShowMoreProps) => {
  const [isHover, setIsHover] = useState<boolean>(false);
  const isEstesa = useTypedSelector(selectIsVisualizzazioneEstesa);

  const objIcon = useMemo(() => {
    return (
      <Icon iconId={IconsEnum.DOUBLE_CHEVRON_RIGHT} className={styles.icon} color="var(--color-on-bg-secondary)" />
    );
  }, []);

  return (
    <div
      className={classNames(styles.container, className ? className : '')}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className={classNames(!isEstesa ? styles.link : styles.estesaLink)}>{objIcon}</div>
      {!!results && <p className={`${styles.info} ${isHover ? styles.visible : styles.hidden}`}>{results}</p>}
    </div>
  );
};